export class Notice {
    constructor() {
        this.notice = null;
        this.init();
    }



    init() {
        this.notice = document.querySelector('.c-notice');
        
        if (!this.notice) {
            return;
        }

        // Check if user has previously dismissed the notice in this session
        if (sessionStorage.getItem('notice-dismissed') === 'true') {
            // Hide notice immediately with display: none
            this.notice.classList.add('c-notice--hidden');
            document.body.classList.remove('has-notice');
            
            // Set height to 0 immediately
            const property = this.notice.dataset.var;
            if (property) {
                document.documentElement.style.setProperty(`--${property}`, '0px');
            }
            
            // Dispatch event to notify Height.js to recalculate
            window.dispatchEvent(new CustomEvent('notice-closed', {
                detail: { property: property }
            }));
            
            // Remove from DOM after a brief delay
            setTimeout(() => {
                if (this.notice) {
                    this.notice.remove();
                    this.notice = null;
                }
            }, 50);
            return;
        }

        // Show the notice with smooth animation
        this.notice.classList.add('c-notice--show');
        document.body.classList.add('has-notice');

        // Bind close button event
        this.bindEvents();
    }

    bindEvents() {
        const closeButton = this.notice.querySelector('.c-notice__close');
        if (closeButton) {
            closeButton.addEventListener('click', () => this.closeNotice());
        }

        // Optional: Close on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.notice && document.body.contains(this.notice)) {
                this.closeNotice();
            }
        });
    }

    closeNotice() {
        if (!this.notice) {
            return;
        }

        // Get the property name before removing the element
        const property = this.notice.dataset.var;

        // Add closing animation class
        this.notice.classList.remove('c-notice--show');
        this.notice.classList.add('c-notice--closing');
        
        // Remove the notice after animation
        setTimeout(() => {
            if (this.notice && document.body.contains(this.notice)) {
                this.notice.remove();
                document.body.classList.remove('has-notice');
                
                // Manually set the CSS variable to 0 since the element is gone
                if (property) {
                    document.documentElement.style.setProperty(`--${property}`, '0px');
                }
                
                // Dispatch custom event to notify other components
                window.dispatchEvent(new CustomEvent('notice-closed', {
                    detail: { property: property }
                }));
                
                // Store in sessionStorage to remember user preference for this session only
                sessionStorage.setItem('notice-dismissed', 'true');
                
                this.notice = null;
            }
        }, 300);
    }

    // Public method to programmatically close notice
    static close() {
        const notice = document.querySelector('.c-notice');
        if (notice) {
            const noticeInstance = new Notice();
            noticeInstance.notice = notice;
            noticeInstance.closeNotice();
        }
    }
}